module.exports = __webpack_public_path__ + "media/img/specialize/mobile/item5-c7f9eb67fefbcdc61455da3108d38369.svg";